import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import * as FileSaver from "file-saver";
import XLSX from "xlsx";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Select from "react-select";
import FloatingButton from "../../../Material/FloatingButton";

toast.configure();
class pendingList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MyApplicationList: [],
      deletePopup: false,
      approverList: [],
      Referenceno: "",
      deleteReferenceno: "",
      loading: "",
      errorStatus: false,
      Remarks: "",
      approvePopup: false,
      rejectPopup: false,
      downloadExcel: [],
      detailArray: "",
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "My Task : Pending List",
    });
    this.GetListData("Pending");
  }

  GetListData = (val) => {
    try {
      let postData = { UserId: this.props.UserId, Status: val, userType: "" };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/MyTask/MyTaskList", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              MyApplicationList: data?.resultObject,
              loading: "Yes",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  confirmApprover = (value, tableMeta, updateValue) => {
    try {
      if (!tableMeta.rowData?.[2].includes("Employee Clearance")) {
        this.setState({
          approvePopup: true,
          Referenceno: tableMeta.rowData?.[0],
          detailArray: tableMeta.rowData,
        });
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            `/api/eDoc/GetWorkflowApprovers?ReferenceNo=${tableMeta.rowData?.[0]}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                approverList: data?.resultObject,
                loading: "Yes",
              });
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        var CryptoJS = require("crypto-js");
        window.location =
          process.env.REACT_APP_ENV +
          "/mytask/pending/view?p=" +
          encodeURI(
            CryptoJS.AES.encrypt(
              JSON.stringify(tableMeta.rowData?.[0]),
              process.env.REACT_APP_ENCRYPT_PASSWORD
            ).toString()
          );
      }
    } catch (e) {
      console.log(e);
    }
  };

  confirmReject = (value, tableMeta, updateValue) => {
    this.setState({
      rejectPopup: true,
      deleteReferenceno: tableMeta.rowData?.[0],
      detailArray: tableMeta.rowData,
    });
  };

  approverRequest = () => {
    try {
      let postData = {
        referenceNo: this.state.Referenceno,
        userId: parseInt(this.props.UserId),
        remarks: this.state.Remarks,
        wfStatus: "Approved",
      };
      this.setState({
        MyApplicationList: [],
        loading: "",
      });
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/ApproveRejecteDoc",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.GetListData("Pending");
            this.setState({
              approvePopup: false,
              Remarks: "",
              detailArray: "",
            });
            toast.success("Request approved successfully.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  rejectRequest = () => {
    try {
      if (this.state.Remarks) {
        let postData = {
          referenceNo: this.state.deleteReferenceno,
          userId: parseInt(this.props.UserId),
          remarks: this.state.Remarks,
          wfStatus: "Rejected",
        };
        this.setState({
          MyApplicationList: [],
          loading: "",
        });
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/ApproveRejecteDoc",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              this.GetListData("Pending");
              this.setState({
                rejectPopup: false,
                Remarks: "",
                detailArray: "",
              });
              toast.success("Request rejected successfully.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ errorStatus: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  cancelApprove = () => {
    this.setState({
      Remarks: "",
      approvePopup: false,
      detailArray: "",
      errorStatus: false,
    });
  };

  cancelReject = () => {
    this.setState({
      Remarks: "",
      rejectPopup: false,
      detailArray: "",
      approvePopup: false,
    });
  };

  viewRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/pending/view?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  editRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/pending/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  deleteRequest = (value, tableMeta, updateValue) => {
    this.setState({
      deletePopup: true,
      deleteReferenceno: tableMeta?.rowData[0],
    });
  };

  cancelDelete = () => {
    this.setState({ deletePopup: false, deleteReferenceno: "" });
  };

  confirmDelete = () => {
    try {
      this.setState({
        MyApplicationList: [],
        loading: "",
      });
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteeDocRequest?ReferenceNo=${this.state.deleteReferenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            toast.success("Deleted successfully.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.setState({ deletePopup: false, deleteReferenceno: "" });
            this.GetListData("Pending");
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  textHandler = (value) => {
    this.setState({ ...this.state, Remarks: value });
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "Reference No",
        header2: "Employee Name",
        header3: "eDoc Type",
        header4: "Submitted Date",
        header5: "Status",
        header6: "Description",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel?.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            value.data[5],
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.MyApplicationList.forEach((data) => {
          let mdData = [
            data.referenceno,
            data.employee,
            data.edoctype,
            data.submitteddate,
            data.status,
            data.description,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "pending.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  workflowRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/pending/workflow?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  printRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/mytask/pending/print?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  render() {
    let approverlist = [];
    this.state.approverList?.map((data) => {
      approverlist.push({
        value: data.oriapproverid,
        label: data.oriapprovername,
      });
    });
    let dataArray = [];
    this.state.MyApplicationList?.map((data) => {
      let mdData = [
        data.referenceno,
        data.employee,
        data.edoctype,
        data.submitteddate
          ? moment(data.submitteddate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        data.status,
        data.description,
      ];
      dataArray.push(mdData);
      return null;
    });

    const columns = [
      {
        name: "referenceno",
        label: "Reference No",
        options: {
          filter: false,
          sort: true,
        },
        editable: true,
      },
      {
        name: "employee",
        label: "Employee Name",
        options: {
          filter: true,
          sort: true,
        },
        editable: true,
      },
      {
        name: "edoctype",
        label: "eDoc Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "submitteddate",
        label: "Submitted Date",
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <div className="badge badge-pending">{value}</div>
              </>
            );
          },
        },
      },
      {
        name: "description",
        label: "Description",
        options: {
          filter: true,
          sort: true,
          // customBodyRender: (value) => {
          //   const maxLength = 30;
          //   if (value.length > maxLength) {
          //     return (
          //       <Tooltip title={value}>
          //         <span>{value.substring(0, maxLength) + "..."}</span>
          //       </Tooltip>
          //     );
          //   }
          //   return value;
          // },
          customBodyRender: (value) => {
            const hasHtml = /<\/?[a-z][\s\S]*>/i.test(value);
            if (hasHtml) {
              return (
                <span
                  dangerouslySetInnerHTML={{
                    __html: value,
                  }}></span>
              );
            } else {
              const maxLength = 30;
              if (value.length > maxLength) {
                return (
                  <Tooltip title={value}>
                    <span>{value.substring(0, maxLength) + "..."}</span>
                  </Tooltip>
                );
              }
              return value;
            }
          },
        },
      },
      // {
      //   name: "description",
      //   label: "Description",
      //   options: {
      //     filter: true,
      //     sort: true,
      //   },
      // },
      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <ReactTooltip />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/Icon-feather-check.svg"
                  }
                  data-tip="Approve"
                  alt="View"
                  onClick={() =>
                    this.confirmApprover(value, tableMeta, updateValue)
                  }
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/ionic-md-close.svg"
                  }
                  data-tip="Reject"
                  alt="Metro Flow Tree"
                  onClick={() =>
                    this.confirmReject(value, tableMeta, updateValue)
                  }
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/awesome-eye.svg"
                  }
                  alt="View"
                  onClick={() =>
                    this.viewRequest(value, tableMeta, updateValue)
                  }
                  data-tip="View"
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/metro-flow-tree.svg"
                  }
                  data-tip="WorkFlow"
                  alt="Metro Flow Tree"
                  onClick={() =>
                    this.workflowRequest(value, tableMeta, updateValue)
                  }
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/print-standard-pdf.svg"
                  }
                  alt="Standard Print"
                  onClick={() =>
                    this.printRequest(value, tableMeta, updateValue)
                  }
                  data-tip="Standard Print"
                />
              </>
            );
          },
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}>
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
          </>
        );
      },
    };

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>My Task : Pending List</Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-xs-2">
          {" "}
          <MUIDataTable
            title={"My Task : Pending List"}
            data={dataArray}
            columns={columns}
            options={options}
          />{" "}
        </div>
        <p className="text-center"></p>
        <Modal show={this.state.deletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmDelete}>
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.approvePopup} size="xl">
          <Modal.Header>Approve Request</Modal.Header>
          <Modal.Body>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    Reference No{" "}
                  </label>
                  <p class="form-value"> {this.state.Referenceno} </p>
                </div>
                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    eDoc Type{" "}
                  </label>
                  <p class="form-value"> {this.state.detailArray?.[2]} </p>
                </div>
                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    Requester Name{" "}
                  </label>

                  <p class="form-value"> {this.state.detailArray?.[1]} </p>
                </div>
                <div class="col-sm-12">
                  <label for="" class="form-label">
                    {" "}
                    Description{" "}
                  </label>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: this.state.detailArray?.[5],
                    }}
                  />
                  {/* <p class="form-value"> {this.state.detailArray?.[5]} </p> */}
                </div>

                <div class="col-sm-12">
                  <label for="" className="col-form-label text-muted">
                    Comments
                  </label>
                  <textarea
                    className="form-control"
                    placeholder=""
                    rows="3"
                    name="Remarks"
                    defaultValue={this.state.Remarks && this.state.Remarks}
                    onChange={(e) =>
                      this.textHandler(e.target.value)
                    }></textarea>
                </div>
                {/* {this.state.errorStatus && !this.state.Remarks && (
                  <div class="col-sm-12">
                    <p style={{ color: "red", fontSize: "14px" }}>
                      This field is required *
                    </p>
                  </div>
                )} */}
              </div>
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelApprove}>
                {" "}
                Cancel{" "}
              </Button>
              <Button
                className="btn btn-success ml-3"
                onClick={this.approverRequest}>
                {" "}
                Approve Request
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.rejectPopup} size="xl">
          <Modal.Header>Reject Request</Modal.Header>
          <Modal.Body>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    Reference No{" "}
                  </label>
                  <p class="form-value"> {this.state.deleteReferenceno} </p>
                </div>
                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    eDoc Type{" "}
                  </label>
                  <p class="form-value"> {this.state.detailArray?.[2]} </p>
                </div>

                <div class="col-sm-6">
                  <label for="" class="form-label">
                    {" "}
                    Requester Name{" "}
                  </label>
                  <p class="form-value"> {this.state.detailArray?.[1]} </p>
                </div>
                <div class="col-sm-12">
                  <label for="" class="form-label">
                    {" "}
                    Description{" "}
                  </label>
                  <p
                    // sanitize first if you don’t fully trust the source:
                    dangerouslySetInnerHTML={{
                      __html: this.state.detailArray?.[5],
                    }}
                  />
                  {/* <p class="form-value"> {this.state.detailArray?.[5]} </p> */}
                </div>
                <div class="col-sm-12">
                  <label for="" className="col-form-label text-muted">
                    Comments
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Comment is mandatory for rejection"
                    rows="3"
                    name="Remarks"
                    defaultValue={this.state.Remarks}
                    onChange={(e) =>
                      this.textHandler(e.target.value)
                    }></textarea>
                </div>
                {this.state.errorStatus && !this.state.Remarks && (
                  <div class="col-sm-12">
                    <p style={{ color: "red", fontSize: "14px" }}>
                      This field is required *
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelReject}>
                {" "}
                Cancel{" "}
              </Button>
              <Button
                className="btn btn-danger ml-3"
                onClick={this.rejectRequest}>
                {" "}
                Reject Request
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(pendingList);
